import React from 'react';
import './EnvironmentBuildBadge.css';

const environmentLabel = process.env.REACT_APP_ENVIRONMENT_LABEL;
const deployedSha = process.env.REACT_APP_DEPLOYED_SHA;
const SHA_PATTERN = /^[0-9a-f]{40}$/i;

/**
 * Persistent, build-time deployment identity. Values are public deployment
 * metadata only; React renders them as text, so they are never HTML-interpreted.
 */
function EnvironmentBuildBadge() {
    if (!environmentLabel) {
        return null;
    }

    const shortSha = SHA_PATTERN.test(deployedSha || '')
        ? deployedSha.slice(0, 12)
        : 'SHA UNAVAILABLE';

    return (
        <aside className="environment-build-badge" aria-label={`${environmentLabel} environment build ${shortSha}`}>
            <span className="environment-build-badge__label">{environmentLabel}</span>
            <span className="environment-build-badge__separator" aria-hidden="true">·</span>
            <code className="environment-build-badge__sha">{shortSha}</code>
        </aside>
    );
}

export default EnvironmentBuildBadge;
